export default "__VITE_ASSET__Crw9Bbwx__"